import React from 'react';
import { Control, Link, Slider } from 'MWC';
import Calculator from '../../../auxiliary-components/Calculator';
import { LANG } from '../../../services/l10n';
import Order from '../../Cards/views/orderAction';
import Banner from "../../../auxiliary-components/shared/Banner";
import ut_card_banner from "../img/ut_card_banner.png";
import services_ut_card from "../img/services_ut.png";
import ut_card from "../img/ut_card.png";
import partner_wog from "../img/wog_logo.png";
import partner_epic from "../img/epicentrk_logo.png";
import partner_foxtrot from "../img/foxtrot_logo.png";
import TabsNew from "../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../auxiliary-components/shared/UsageBlock";
import usage_block_data from "../../GreenCard/enums/usage_block_data.json";
import DownloadApp from "../../Cards/views/downloadApp.c";
import download_block_img from "../../GreenCard/img/download_block_img.png";
import Table from "../../../auxiliary-components/shared/Table";
import table_data from "../enums/ut_table_data.json";
import share_icon from "../../Cards/ProjectSupport/img/share_icon.svg";
import QuestionsBlock from "../../../auxiliary-components/shared/QuestionsBlock";
import questions from "../enums/ut_questions.json";
import '../less/ut-card.less';
import TextAboveFooter from "../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import {Helmet} from "react-helmet-async";
import FilesForDownload from '../../../auxiliary-components/shared/FilesForDownload';
import scrollToOrder from 'utils/scrollToOrder';
import QuestionsAdminBlock from "../../../auxiliary-components/shared/QuestionsAdmin";
import { Preloader } from "MWComponents";
import SliderComponent from "../../../auxiliary-components/shared/Slider";


export default function template() {
    const isMobile = this.isViewportMobile(),
        {viewport} = this.props,
        modes = [ {mode: 'info', title: 'GREEN_CARD_NAV_TITLE_1'},
            {mode: 'tariffs', title: 'GREEN_CARD_NAV_TITLE_2'},
            {mode: 'questions', title: 'GREEN_CARD_NAV_TITLE_3'}],
        page = 'ut-card',
        infoUt = 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Cart/Istot_Zelena_UR_ua.pdf',
        tariffsUt ='https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zelena_UR_ua.pdf',
        termsAndConditions = 'https://conditions-and-rules.a-bank.com.ua/main/view-content-518/?lang=uk',
        model = this.getModel();
    const metaData = [
        {"name": "title", "content": "Картка «Українці Разом» від àбанку та ВО «УКРАЇНЦІ РАЗОМ»"},
        {"name": "description", "content": "Знижки до 50% \uD83D\uDCB8 Кешбек до 20% на покупки \uD83C\uDF81 Кредитний ліміт від 0 до 200 000 ₴ \uD83D\uDCB3 Пільговий період до 62 днів \uD83D\uDCC6 Надання безоплатної вторинної правової допомоги \uD83C\uDD98"},
        {"property": "og:title", "content": "Картка «Українці Разом» від àбанку та ВО «УКРАЇНЦІ РАЗОМ»"},
        {"property": "og:site_name", "content": "Картка «Українці Разом» від àбанку та ВО «УКРАЇНЦІ РАЗОМ»"},
        {"property": "og:url", "content": "https://a-bank.com.ua/cards/ukrainians_together"},
        {"property": "og:image", "content": "https://drive.google.com/file/d/15Y8-i4YYkdomf_uZNFuz5IE5QhHDFq9o/view?usp=sharing"},
        {"property": "og:description", "content": "Знижки до 50% \uD83D\uDCB8 Кешбек до 20% на покупки \uD83C\uDF81 Кредитний ліміт від 0 до 200 000 ₴ \uD83D\uDCB3 Пільговий період до 62 днів \uD83D\uDCC6 Надання безоплатної вторинної правової допомоги \uD83C\uDD98"},
    ]

    if (model.setRealRate) {
        model.setRealRate(this.l10n('CALCULATOR_CREDIT_CARDS_REAL_YEAR_RATE_1'));
    }

    const calculator = !model.creditSum ? (
            ''
        ) : (
            <div className="credit-calculator">
                <div className="calculator-wrapper">
                    <Calculator model={this.getModel()} type="credit_cards" {...this.props} />
                </div>
            </div>
        ),
        isUtm = this.props.location.search.indexOf('utm_') !== -1,
        orderCards = (
            <div className="card-order-wrapper" id='order'>
                <div className="left-side">
                    <div className="title">{this.l10n('GC_WANT_TO_ORDER')}</div>
                    <div className="sub-title">{this.l10n('GC_WANT_TO_ORDER_SUBTITLE')}</div>
                    <div className="card-order">
                        <div className="order-wrapper green-card">
                            <Order
                                {...this.props}
                                row={!this.isViewportMobile()}
                                utmParams={this.utmParams}
                                type="ukrainians_together"
                            />
                        </div>
                    </div>
                </div>
                <img className="order-img" alt="order_green_card" src={ut_card}></img>
            </div>
        ),
            app = isMobile && isUtm ?
                (
                  <div className="content">
                      {orderCards}
                  </div>
                )
                :
                (<div className="download-app-wrapper" id='order'>
                    <div className="download-app-wrapper">
                        <DownloadApp {...this.props} />
                    </div>
            </div>);

    return (
        <>
            <Helmet
              meta={metaData}
            >
                <title>{'Картка «Українці Разом» від àбанку та ВО «УКРАЇНЦІ РАЗОМ»'}</title>
            </Helmet>

            <div className="ut-card">
                <div className='slider-container'>
                    {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')}></SliderComponent>}
                </div>

                <TabsNew modes={modes} isMobile={isMobile} page={'quick-cash'} toggle={this.toggleMode} mode={this.state.mode}>
                    <div className="wrapper" type={modes[0].mode}>
                        <div className="content">
                            <UsageBlock isMobile={isMobile} page={page} data={usage_block_data} className="col-3-row-2"></UsageBlock>
                            {isMobile ? '' : orderCards}
                        </div>

                        <div className="partners">
                            <div className="partners-title">{this.l10n('UT_PARTNERS_CARD_TITLE')}</div>
                            <div className="partners-block-wrapper">
                                <div className="partners-block">
                                    <div className="content-wrapper">
                                        <img className="wog-logo" alt="wog_img" src={partner_wog}></img>
                                        <div className="partners-block-title">{this.l10n('UT_PARTNERS_CARD_WOG_TITLE')}</div>
                                        <div className="partners-block-text">{this.l10n('UT_PARTNERS_CARD_WOG_TEXT_1')}</div>
                                        <div className="partners-block-text-3">{this.l10n('UT_PARTNERS_CARD_WOG_TEXT_5')}</div>
                                        <div className="partners-block-items-wrapper">
                                            <ul className="partners-block-items">
                                                <li>
                                                    {this.l10n('UT_PARTNERS_CARD_WOG_DISCOUNT_1')}
                                                </li>
                                                <li>
                                                    {this.l10n('UT_PARTNERS_CARD_WOG_DISCOUNT_2')}
                                                </li>
                                                <li>
                                                    {this.l10n('UT_PARTNERS_CARD_WOG_DISCOUNT_3')}
                                                </li>
                                            </ul>
                                            <div className="partners-block-text-3">{this.l10n('UT_PARTNERS_CARD_WOG_TEXT_6')}</div>
                                            <ul className="partners-block-items">
                                                <li>
                                                    {this.l10n('UT_PARTNERS_CARD_WOG_DISCOUNT_4')}
                                                </li>
                                                <li>
                                                    {this.l10n('UT_PARTNERS_CARD_WOG_DISCOUNT_5')}
                                                </li>

                                            </ul>
                                        </div>

                                        <div className="partners-block-text-2">
                                            <div className="hot-line">{this.l10n('UT_PARTNERS_CARD_WOG_TEXT_2')}</div>
                                            <div className="phone">{this.l10n('UT_PARTNERS_CARD_WOG_TEXT_3')}</div>
                                            <div className="link">
                                                {this.l10n('UT_PARTNERS_CARD_WOG_TEXT_4')}
                                                <a className="link" href="https://www.wog.ua" target="_blank">
                                                    {this.l10n('UT_PARTNERS_CARD_WOG_LINK')}
                                                    <img alt="href_img" src={share_icon}></img>
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                </div>

                                <div className="partners-block epic">
                                    <div className="content-wrapper">
                                        <img className="epic-logo" alt="epicentr_img" src={partner_epic}></img>
                                        <div className="partners-block-title">{this.l10n('UT_PARTNERS_CARD_EPICENTR_TITLE')}</div>
                                        <div className="partners-block-text">{this.l10n('UT_PARTNERS_CARD_EPICENTR_TEXT_1')}</div>
                                        <div className="partners-block-items-wrapper">
                                            <ul className="partners-block-items">
                                                <li className="epic-item">
                                                    {this.l10n('UT_PARTNERS_CARD_EPICENTR_DISCOUNT')}
                                                </li>
                                            </ul>
                                            <div className="warning-discount-epicentr">
                                                {this.l10n('UT_PARTNERS_CARD_EPICENTR_WARNING')}
                                            </div>
                                        </div>

                                        <div className="partners-block-text-2">
                                            <div className="hot-line">{this.l10n('UT_PARTNERS_CARD_EPICENTR_TEXT_2')}</div>
                                            <div className="phone">{this.l10n('UT_PARTNERS_CARD_EPICENTR_TEXT_3')}</div>
                                            <div className="link">
                                                {this.l10n('UT_PARTNERS_CARD_EPICENTR_TEXT_4')}
                                                <a className="link" href="https://epicentrk.ua" target="_blank">
                                                    {this.l10n('UT_PARTNERS_CARD_EPICENTR_LINK')}
                                                    <img alt="href_img" src={share_icon}></img>
                                                </a>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="partners-block foxtrot">
                                    <div className="content-wrapper">
                                        <img className="wog-logo" alt="foxtrot_img" src={partner_foxtrot}></img>
                                        <div className="partners-block-title">{this.l10n('UT_PARTNERS_CARD_FOXTROT_TITLE')}</div>
                                        <div className="partners-block-text">{this.l10n('UT_PARTNERS_CARD_FOXTROT_TEXT_1')}</div>
                                        <div className="partners-block-items-wrapper">
                                            <ul className="partners-block-items foxtrot">
                                                <li>
                                                    {this.l10n('UT_PARTNERS_CARD_FOXTROT_DISCOUNT_1')}
                                                </li>
                                                <li>
                                                    {this.l10n('UT_PARTNERS_CARD_FOXTROT_DISCOUNT_2')}
                                                </li>
                                            </ul>
                                            <div className="warning-discount-foxtrot">
                                                {this.l10n('UT_PARTNERS_CARD_FOXTROT_WARNING')}
                                            </div>
                                        </div>

                                        <div className="partners-block-text-2">
                                            <div className="hot-line-phone">{this.l10n('UT_PARTNERS_CARD_FOXTROT_TEXT_2')}</div>
                                            <div className="link">
                                                {this.l10n('UT_PARTNERS_CARD_FOXTROT_TEXT_3')}
                                                <a className="link" href="https://foxtrot.com.ua" target="_blank">
                                                    {this.l10n('UT_PARTNERS_CARD_FOXTROT_LINK')}
                                                    <img alt="href_img" src={share_icon}></img>
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="partners-more-info">
                                {this.l10n('UT_PARTNERS_CARD_MORE_INFO')}
                                <a className="link" href="https://kartka.ukrazom.org/partners" target="_blank">
                                    {this.l10n('UT_PARTNERS_CARD_MORE_INFO_LINK')}
                                    <img alt="href_img" src={share_icon}></img>
                                </a>
                            </div>
                        </div>

                        <div className="services-card-wrapper">
                            <div className="services-card">
                                <div className="services-card-left-side">
                                    <div className="services-card-left-side-title">{this.l10n('UT_SERVICES_CARD_TITLE')}</div>
                                    <div className="services-card-left-side-text">
                                        <ul>
                                            <li className="green">
                                                {this.l10n('UT_SERVICES_CARD_TEXT_1')}
                                            </li>
                                            <li className="ordinary">
                                                {this.l10n('UT_SERVICES_CARD_ITEM_1')}
                                            </li>
                                            <li className="green">
                                                {this.l10n('UT_SERVICES_CARD_TEXT_2')}
                                            </li>
                                            <li className="ordinary">
                                                {this.l10n('UT_SERVICES_CARD_ITEM_2')}
                                            </li>
                                            <li className="green">
                                                {this.l10n('UT_SERVICES_CARD_TEXT_3')}
                                            </li>
                                            <li className="ordinary">
                                                {this.l10n('UT_SERVICES_CARD_ITEM_3')}
                                            </li>
                                            <li className="green">
                                                {this.l10n('UT_SERVICES_CARD_TEXT_4')}
                                            </li>
                                            <li className="ordinary">
                                                {this.l10n('UT_SERVICES_CARD_ITEM_4')}
                                            </li>
                                            <li className="green">
                                                {this.l10n('UT_SERVICES_CARD_TEXT_5')}
                                            </li>
                                            <li className="ordinary">
                                                {this.l10n('UT_SERVICES_CARD_ITEM_5')}
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                                <div className="services-card-right-side">
                                    <img alt="services_card_img" src={services_ut_card}></img>
                                </div>
                            </div>
                        </div>

                        <div className="content">
                            {calculator}
                        </div>

                        <div className="get-card-wrapper">
                            <div className="get-card">
                                <div className="get-card-title">{this.l10n('UT_GET_CARD_TITLE')}</div>
                                <div className="get-card-text">
                                    <div className="get-card-text-1">
                                        {this.l10n('UT_GET_CARD_TEXT_1')}
                                        <a className="link" href="https://www.ukrazom.org/contacts-card" target="_blank">
                                            {this.l10n('UT_GET_CARD_TEXT_2')}
                                            <img alt="href_img" src={share_icon}></img>
                                        </a>
                                        {this.l10n('UT_GET_CARD_TEXT_3')}
                                    </div>
                                    {this.l10n('UT_GET_CARD_TEXT_4')}
                                    <ul className="get-card-text-1-items">
                                        <li className="get-card-text-1-item">
                                            {this.l10n('UT_GET_CARD_ITEM_1')}
                                        </li>
                                        <li className="get-card-text-1-item">
                                            {this.l10n('UT_GET_CARD_ITEM_2')}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {isMobile ? app : ''}
                    </div>

                    <div className="wrapper" type={modes[1].mode}>
                        <div className="content">
                            <Table data={table_data} page={page} isMobile={isMobile} toggle={this.toggleMode}></Table>
                            <div className="tariffs-desc">
                                {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_1')}
                                <a className="link" href={tariffsUt} target="_blank">
                                    {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_2')}
                                    <img alt="href_img" src={share_icon}></img>
                                </a>
                            </div>
                        </div>
                        {app}
                    </div>

                    <div className="wrapper" type={modes[2].mode}>
                        <div className="content">
                            <QuestionsAdminBlock page={page} isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'questions')}></QuestionsAdminBlock>
                        </div>
                        {app}
                    </div>
                </TabsNew>
                <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}></FilesForDownload>


                <div className={`disclaimer-wrapper tab-${this.state.mode === 'info' ? 'active' : 'hidden'}`}>
                    <TextAboveFooter isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}></TextAboveFooter>
                </div>
            </div>
        </>
    );
}
